import React from 'react';
import { Link } from 'react-router-dom';

interface EventDayOpsBarProps {
  eventId: number;
  slug: string;
  status: string;
}

const linkClass =
  'inline-flex items-center justify-center min-h-[44px] px-3 rounded-lg border border-white/[0.08] bg-[#141414] text-sm text-gray-200 hover:border-orange-500/40 hover:text-orange-200 transition-colors duration-200 cursor-pointer';

/**
 * Persistent day-of shortcuts so organizers do not hunt through tabs.
 */
const EventDayOpsBar: React.FC<EventDayOpsBarProps> = ({ eventId, slug, status }) => {
  const published = status === 'published' || status === 'completed';

  return (
    <section
      className="rounded-xl border border-white/[0.06] bg-[#0c0c0c]/80 p-4 mb-6"
      aria-label="Event day tools"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <h2 className="text-sm font-semibold text-white">Day-of tools</h2>
        <p className="text-xs text-gray-500">Use these on event day. Setup lives in the tabs below.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {published ? (
          <>
            <Link to={`/organizer/events/${eventId}/checkin`} className={linkClass}>
              Vehicle check-in
            </Link>
            <Link to={`/organizer/events/${eventId}/gate`} className={linkClass}>
              Gate scan
            </Link>
          </>
        ) : (
          <p className="text-sm text-amber-200/90">
            Publish the event to unlock check-in and gate scan.
          </p>
        )}
        <Link to={`/events/${slug}`} className={linkClass}>
          Public page
        </Link>
        <Link to="/organizer/payments" className={linkClass}>
          Payout setup
        </Link>
        {status === 'completed' || status === 'published' ? (
          <Link to={`/events/${slug}/archive`} className={linkClass}>
            Archive
          </Link>
        ) : null}
      </div>
    </section>
  );
};

export default EventDayOpsBar;
